// i18n translations for LT (default), EN, DE, RU
// Architecture allows easy addition of future languages.

export const translations = {
  lt: {
    nav: {
      home: 'Pradžia',
      about: 'Apie mus',
      investments: 'Investicijos',
      real_estate: 'Nekilnojamasis turtas',
      asset_management: 'Turto valdymas',
      contact: 'Kontaktai',
      admin: 'Administravimas',
    },
    home: {
      tagline: 'Privačios kapitalo investicijos. Nekilnojamasis turtas. Vizijos.',
      hero_title: 'Architektūra. Kapitalas. Pasitikėjimas.',
      hero_sub: 'UAB MAIŠIAGALA GROUP — investicijų ir nekilnojamojo turto plėtros įmonė, formuojanti ilgalaikę vertę.',
      cta: 'Susisiekite',
      intro_title: 'Investicijos su architekto vizija',
      scroll: 'Slinkti',
      get_in_touch: 'Susisiekite',
      intro_body: 'Esame privati investicinė ir nekilnojamojo turto plėtros įmonė, valdanti komercinio ir gyvenamojo turto portfelį, struktūrizuojanti investicinius projektus ir prižiūrinti turto valdymą Lietuvoje.',
      areas_title: 'Pagrindinės veiklos sritys',
      areas: [
        { t: 'Investicijos į nekilnojamąjį turtą', d: 'Strateginis komercinio ir gyvenamojo turto įsigijimas vidutinės ir ilgalaikės vertės kūrimui.' },
        { t: 'Nekilnojamojo turto plėtra ir statyba', d: 'Pilna projektų plėtra: nuo žemės sklypo iki perdavimo investuotojui.' },
        { t: 'Turto valdymas', d: 'Profesionalus turto, investicijų ir sandorių administravimas su finansine kontrole.' },
        { t: 'Investicijų ir nekilnojamojo turto konsultacijos', d: 'Nepriklausomas patarimas instituciniams ir privatiems investuotojams.' },
        { t: 'Investicinių projektų struktūrizavimas', d: 'Sandorių struktūros, finansavimo modeliai ir partnerystės schemos.' },
      ],
      advantages_title: 'Mūsų privalumai',
      advantages: [
        { t: 'Architektūrinis tikslumas', d: 'Kiekvieno projekto pagrindas — tiksli inžinerija ir estetinė vizija.' },
        { t: 'Kapitalo stabilumas', d: 'Konservatyvus rizikos valdymas ir skaidri investicijų struktūra.' },
        { t: 'Visapusiškas valdymas', d: 'Nuo idėjos iki nuolatinio turto administravimo.' },
        { t: 'Ilgalaikė perspektyva', d: 'Investicijos su orientacija į tvarią vertės kūrimą.' },
      ],
    },
    about: {
      title: 'Apie įmonę',
      mission_title: 'Misija',
      mission_body: 'Kurti ilgalaikę vertę per disciplinuotas investicijas, architektūrinę kokybę ir nepriekaištingą turto valdymą.',
      values_title: 'Vertybės',
      values: ['Skaidrumas', 'Kokybė', 'Ilgalaikė perspektyva', 'Partnerystė'],
      strategy_title: 'Plėtros strategija',
      strategy_body: 'Koncentruojamės į A++ klasės komercinį turtą Baltijos regiono ir Vakarų Europos sostinėse, į premium klasės gyvenamuosius projektus pasirinktose vietovėse ir į oportunistines plėtros pozicijas.',
      history_title: 'Istorija',
      history_body: 'UAB MAIŠIAGALA GROUP įsteigta kaip privati investicinė platforma, siekianti tapti pasirenkamu partneriu instituciniams ir privatiems investuotojams.',
    },
    investments: {
      title: 'Investicijos',
      lead: 'Disciplinuotos pozicijos trijose investicijų klasėse.',
      strategy_title: 'Investicijų strategija',
      strategy_body: 'Mes vertiname kiekvieną sandorį pagal vidinį kapitalo grąžos ribą (IRR), tvarumą ir architektūrinę vertę. Mūsų portfelis subalansuotas tarp pasyvių pajamų generavimo ir kapitalo augimo.',
      categories: {
        commercial: { t: 'Komercinis NT', d: 'A++ klasės biurai, mažmeninės prekybos turtas ir logistikos kompleksai.' },
        residential: { t: 'Gyvenamasis NT', d: 'Premium klasės butai ir gyvenamieji projektai pasirinktose vietovėse.' },
        development: { t: 'Plėtros projektai', d: 'Žemė ir vystymo pozicijos su aukšta vertės kūrimo potencija.' },
      },
    },
    realestate: {
      title: 'Nekilnojamasis turtas ir statyba',
      lead: 'Pilno ciklo plėtra — nuo žemės iki perdavimo.',
      services: [
        { t: 'Statyba', d: 'Aukštos kokybės naujos statybos vykdymas su atrinktais rangovais.' },
        { t: 'Rekonstrukcija', d: 'Istorinio ir komercinio turto modernizavimas.' },
        { t: 'Plėtra', d: 'Pilnas plėtros ciklas, įskaitant projektavimą, leidimus ir finansavimą.' },
        { t: 'Projektų valdymas', d: 'Profesionalus projekto valdymas pagal terminus ir biudžetą.' },
      ],
    },
    asset: {
      title: 'Turto valdymas',
      lead: 'Profesionalus, disciplinuotas, skaidrus.',
      services: [
        { t: 'Nekilnojamojo turto valdymas', d: 'Operatyvinis turto valdymas, nuomos administravimas, techninė priežiūra.' },
        { t: 'Investicijų valdymas', d: 'Portfelio konstravimas, perbalansavimas ir veiklos rezultatų stebėsena.' },
        { t: 'Sandorių priežiūra ir administravimas', d: 'Įsigijimų ir pardavimų valdymas su teisine ir finansine kontrole.' },
        { t: 'Finansinė kontrolė', d: 'Ataskaitos, biudžetai, mokesčių optimizavimas ir auditas.' },
      ],
    },
    contact: {
      title: 'Kontaktai',
      lead: 'Susisiekite su mumis dėl investicijų ir partnerystės galimybių.',
      form: {
        name: 'Vardas',
        phone: 'Telefonas',
        email: 'El. paštas',
        message: 'Žinutė',
        submit: 'Siųsti',
        success: 'Ačiū! Susisieksime artimiausiu metu.',
        error: 'Įvyko klaida. Bandykite dar kartą.',
      },
      info: {
        phone: 'Telefonas',
        email: 'El. paštas',
        address: 'Adresas',
        address_value: 'Krivių g. 5-1002, LT-01204, Vilnius, Lietuva',
      },
    },
    footer: { rights: 'Visos teisės saugomos.', privacy: 'Privatumo politika' },
    admin: {
      login: 'Prisijungti su Google',
      title: 'Administravimas',
      projects: 'Projektai',
      news: 'Naujienos',
      messages: 'Žinutės',
      logout: 'Atsijungti',
      add: 'Pridėti',
      edit: 'Redaguoti',
      delete: 'Šalinti',
      save: 'Išsaugoti',
      cancel: 'Atšaukti',
    },
  },
  en: {
    nav: { home: 'Home', about: 'About', investments: 'Investments', real_estate: 'Real Estate', asset_management: 'Asset Management', contact: 'Contact', admin: 'Admin' },
    home: {
      tagline: 'Private capital. Real estate. Vision.',
      hero_title: 'Architecture. Capital. Trust.',
      hero_sub: 'UAB MAIŠIAGALA GROUP is an investment and real estate development company shaping long-term value.',
      cta: 'Contact Us',
      intro_title: 'Investments with an architect’s vision',
      scroll: 'Scroll',
      get_in_touch: 'Get in touch',
      intro_body: 'We are a private investment and real estate development firm managing a portfolio of commercial and residential assets, structuring investment projects and overseeing asset management in Lithuania.',
      areas_title: 'Main business areas',
      areas: [
        { t: 'Real estate investments', d: 'Strategic acquisition of commercial and residential assets for mid-to-long-term value creation.' },
        { t: 'Real estate development and construction', d: 'Full project development — from land plot to investor handover.' },
        { t: 'Asset management', d: 'Professional administration of properties, investments and transactions with financial control.' },
        { t: 'Investment and real estate consulting', d: 'Independent advice for institutional and private investors.' },
        { t: 'Investment project structuring', d: 'Deal structures, financing models and partnership schemes.' },
      ],
      advantages_title: 'Our advantages',
      advantages: [
        { t: 'Architectural precision', d: 'Every project is rooted in precise engineering and aesthetic vision.' },
        { t: 'Capital stability', d: 'Conservative risk management and transparent investment structures.' },
        { t: 'End-to-end management', d: 'From idea to ongoing asset administration.' },
        { t: 'Long-term perspective', d: 'Investments oriented towards sustainable value creation.' },
      ],
    },
    about: {
      title: 'About the Company',
      mission_title: 'Mission',
      mission_body: 'To create long-term value through disciplined investments, architectural quality, and impeccable asset management.',
      values_title: 'Values',
      values: ['Transparency', 'Quality', 'Long-term perspective', 'Partnership'],
      strategy_title: 'Development strategy',
      strategy_body: 'We focus on A++ class commercial assets in the Baltic and Western European capitals, premium residential projects in selected locations, and opportunistic development positions.',
      history_title: 'History',
      history_body: 'UAB MAIŠIAGALA GROUP was founded as a private investment platform, aiming to become a partner of choice for institutional and private investors.',
    },
    investments: {
      title: 'Investments',
      lead: 'Disciplined positions across three investment classes.',
      strategy_title: 'Investment strategy',
      strategy_body: 'We evaluate every deal against an internal IRR threshold, sustainability and architectural value. Our portfolio is balanced between passive income generation and capital growth.',
      categories: {
        commercial: { t: 'Commercial real estate', d: 'A++ class offices, retail assets and logistics complexes.' },
        residential: { t: 'Residential real estate', d: 'Premium apartments and residential projects in selected locations.' },
        development: { t: 'Development projects', d: 'Land and development positions with high value-creation potential.' },
      },
    },
    realestate: {
      title: 'Real Estate & Construction',
      lead: 'Full-cycle development — from land to handover.',
      services: [
        { t: 'Construction', d: 'High-quality new construction executed with selected contractors.' },
        { t: 'Reconstruction', d: 'Modernization of historical and commercial real estate.' },
        { t: 'Development', d: 'Full development cycle including design, permits and financing.' },
        { t: 'Project management', d: 'Professional project management on time and on budget.' },
      ],
    },
    asset: {
      title: 'Asset Management',
      lead: 'Professional. Disciplined. Transparent.',
      services: [
        { t: 'Property management', d: 'Operational property management, lease administration, technical maintenance.' },
        { t: 'Investment management', d: 'Portfolio construction, rebalancing and performance monitoring.' },
        { t: 'Transaction oversight & administration', d: 'Management of acquisitions and disposals with legal and financial control.' },
        { t: 'Financial control', d: 'Reporting, budgeting, tax optimization and audit.' },
      ],
    },
    contact: {
      title: 'Contact',
      lead: 'Get in touch about investment and partnership opportunities.',
      form: { name: 'Name', phone: 'Phone', email: 'Email', message: 'Message', submit: 'Send', success: 'Thank you! We will be in touch shortly.', error: 'Something went wrong. Please try again.' },
      info: { phone: 'Phone', email: 'Email', address: 'Address', address_value: 'Krivių st. 5-1002, LT-01204, Vilnius, Lithuania' },
    },
    footer: { rights: 'All rights reserved.', privacy: 'Privacy policy' },
    admin: { login: 'Sign in with Google', title: 'Admin', projects: 'Projects', news: 'News', messages: 'Messages', logout: 'Sign out', add: 'Add', edit: 'Edit', delete: 'Delete', save: 'Save', cancel: 'Cancel' },
  },
  de: {
    nav: { home: 'Startseite', about: 'Über uns', investments: 'Investitionen', real_estate: 'Immobilien', asset_management: 'Vermögensverwaltung', contact: 'Kontakt', admin: 'Admin' },
    home: {
      tagline: 'Privates Kapital. Immobilien. Vision.',
      hero_title: 'Architektur. Kapital. Vertrauen.',
      hero_sub: 'UAB MAIŠIAGALA GROUP ist ein Investment- und Immobilienentwicklungsunternehmen, das langfristige Werte schafft.',
      cta: 'Kontakt',
      intro_title: 'Investitionen mit der Vision eines Architekten',
      scroll: 'Scrollen',
      get_in_touch: 'Kontakt aufnehmen',
      intro_body: 'Wir sind ein privates Investment- und Immobilienentwicklungsunternehmen, das ein Portfolio aus Gewerbe- und Wohnimmobilien verwaltet, Investitionsprojekte strukturiert und die Vermögensverwaltung in Litauen überwacht.',
      areas_title: 'Wichtigste Geschäftsfelder',
      areas: [
        { t: 'Immobilieninvestitionen', d: 'Strategischer Erwerb von Gewerbe- und Wohnimmobilien zur mittel- bis langfristigen Wertschöpfung.' },
        { t: 'Immobilienentwicklung und Bau', d: 'Vollständige Projektentwicklung — vom Grundstück bis zur Übergabe an den Investor.' },
        { t: 'Vermögensverwaltung', d: 'Professionelle Verwaltung von Immobilien, Investitionen und Transaktionen mit Finanzkontrolle.' },
        { t: 'Investitions- und Immobilienberatung', d: 'Unabhängige Beratung für institutionelle und private Investoren.' },
        { t: 'Strukturierung von Investitionsprojekten', d: 'Deal-Strukturen, Finanzierungsmodelle und Partnerschaftsschemata.' },
      ],
      advantages_title: 'Unsere Vorteile',
      advantages: [
        { t: 'Architektonische Präzision', d: 'Jedes Projekt basiert auf präziser Ingenieurskunst und ästhetischer Vision.' },
        { t: 'Kapitalstabilität', d: 'Konservatives Risikomanagement und transparente Investitionsstrukturen.' },
        { t: 'End-to-End-Management', d: 'Von der Idee bis zur laufenden Vermögensverwaltung.' },
        { t: 'Langfristperspektive', d: 'Investitionen mit Fokus auf nachhaltige Wertschöpfung.' },
      ],
    },
    about: {
      title: 'Über das Unternehmen',
      mission_title: 'Mission',
      mission_body: 'Langfristigen Wert schaffen durch disziplinierte Investitionen, architektonische Qualität und tadellose Vermögensverwaltung.',
      values_title: 'Werte',
      values: ['Transparenz', 'Qualität', 'Langfristperspektive', 'Partnerschaft'],
      strategy_title: 'Entwicklungsstrategie',
      strategy_body: 'Wir konzentrieren uns auf A++ Klasse Gewerbeimmobilien in baltischen und westeuropäischen Hauptstädten, Premium-Wohnprojekte an ausgewählten Standorten und opportunistische Entwicklungspositionen.',
      history_title: 'Geschichte',
      history_body: 'UAB MAIŠIAGALA GROUP wurde als private Investmentplattform gegründet, mit dem Ziel, ein bevorzugter Partner für institutionelle und private Investoren zu werden.',
    },
    investments: {
      title: 'Investitionen',
      lead: 'Disziplinierte Positionen in drei Anlageklassen.',
      strategy_title: 'Anlagestrategie',
      strategy_body: 'Wir bewerten jedes Geschäft anhand einer internen IRR-Schwelle, Nachhaltigkeit und architektonischem Wert. Unser Portfolio ist ausgewogen zwischen passiver Einkommensgenerierung und Kapitalwachstum.',
      categories: {
        commercial: { t: 'Gewerbeimmobilien', d: 'A++ Klasse Büros, Einzelhandelsobjekte und Logistikkomplexe.' },
        residential: { t: 'Wohnimmobilien', d: 'Premium-Wohnungen und Wohnprojekte an ausgewählten Standorten.' },
        development: { t: 'Entwicklungsprojekte', d: 'Grundstücke und Entwicklungspositionen mit hohem Wertschöpfungspotenzial.' },
      },
    },
    realestate: {
      title: 'Immobilien & Bau',
      lead: 'Vollzyklus-Entwicklung — vom Grundstück bis zur Übergabe.',
      services: [
        { t: 'Bau', d: 'Hochwertige Neubauten, ausgeführt mit ausgewählten Auftragnehmern.' },
        { t: 'Rekonstruktion', d: 'Modernisierung historischer und gewerblicher Immobilien.' },
        { t: 'Entwicklung', d: 'Vollständiger Entwicklungszyklus einschließlich Planung, Genehmigungen und Finanzierung.' },
        { t: 'Projektmanagement', d: 'Professionelles Projektmanagement, termingerecht und im Budget.' },
      ],
    },
    asset: {
      title: 'Vermögensverwaltung',
      lead: 'Professionell. Diszipliniert. Transparent.',
      services: [
        { t: 'Immobilienverwaltung', d: 'Operative Immobilienverwaltung, Mietverwaltung, technische Wartung.' },
        { t: 'Investmentverwaltung', d: 'Portfoliokonstruktion, Rebalancing und Performance-Überwachung.' },
        { t: 'Transaktionsüberwachung & Verwaltung', d: 'Verwaltung von Akquisitionen und Veräußerungen mit rechtlicher und finanzieller Kontrolle.' },
        { t: 'Finanzkontrolle', d: 'Berichterstattung, Budgetierung, Steueroptimierung und Audit.' },
      ],
    },
    contact: {
      title: 'Kontakt',
      lead: 'Kontaktieren Sie uns zu Investitions- und Partnerschaftsmöglichkeiten.',
      form: { name: 'Name', phone: 'Telefon', email: 'E-Mail', message: 'Nachricht', submit: 'Senden', success: 'Vielen Dank! Wir melden uns in Kürze.', error: 'Etwas ist schief gelaufen. Bitte erneut versuchen.' },
      info: { phone: 'Telefon', email: 'E-Mail', address: 'Adresse', address_value: 'Krivių Str. 5-1002, LT-01204, Vilnius, Litauen' },
    },
    footer: { rights: 'Alle Rechte vorbehalten.', privacy: 'Datenschutzrichtlinie' },
    admin: { login: 'Mit Google anmelden', title: 'Admin', projects: 'Projekte', news: 'Nachrichten', messages: 'Nachrichten', logout: 'Abmelden', add: 'Hinzufügen', edit: 'Bearbeiten', delete: 'Löschen', save: 'Speichern', cancel: 'Abbrechen' },
  },
  ru: {
    nav: { home: 'Главная', about: 'О компании', investments: 'Инвестиции', real_estate: 'Недвижимость', asset_management: 'Управление активами', contact: 'Контакты', admin: 'Админ' },
    home: {
      tagline: 'Частный капитал. Недвижимость. Видение.',
      hero_title: 'Архитектура. Капитал. Доверие.',
      hero_sub: 'UAB MAIŠIAGALA GROUP — инвестиционная компания и девелопер недвижимости, формирующая долгосрочную ценность.',
      cta: 'Связаться',
      intro_title: 'Инвестиции с видением архитектора',
      scroll: 'Прокрутить',
      get_in_touch: 'Связаться',
      intro_body: 'Мы — частная инвестиционная и девелоперская компания, управляющая портфелем коммерческой и жилой недвижимости, структурирующая инвестиционные проекты и осуществляющая управление активами в Литве.',
      areas_title: 'Основные направления деятельности',
      areas: [
        { t: 'Инвестиции в недвижимость', d: 'Стратегическое приобретение коммерческих и жилых активов для создания средне- и долгосрочной ценности.' },
        { t: 'Девелопмент и строительство', d: 'Полный цикл реализации проектов — от земельного участка до передачи инвестору.' },
        { t: 'Управление активами', d: 'Профессиональное администрирование объектов, инвестиций и сделок с финансовым контролем.' },
        { t: 'Инвестиционный и риелторский консалтинг', d: 'Независимые рекомендации для институциональных и частных инвесторов.' },
        { t: 'Структурирование инвестиционных проектов', d: 'Структуры сделок, модели финансирования и партнёрские схемы.' },
      ],
      advantages_title: 'Наши преимущества',
      advantages: [
        { t: 'Архитектурная точность', d: 'В основе каждого проекта — точная инженерия и эстетическое видение.' },
        { t: 'Стабильность капитала', d: 'Консервативное управление рисками и прозрачные инвестиционные структуры.' },
        { t: 'Управление полного цикла', d: 'От идеи до постоянного администрирования активов.' },
        { t: 'Долгосрочная перспектива', d: 'Инвестиции с ориентацией на устойчивое создание ценности.' },
      ],
    },
    about: {
      title: 'О компании',
      mission_title: 'Миссия',
      mission_body: 'Создавать долгосрочную ценность через дисциплинированные инвестиции, архитектурное качество и безупречное управление активами.',
      values_title: 'Ценности',
      values: ['Прозрачность', 'Качество', 'Долгосрочная перспектива', 'Партнёрство'],
      strategy_title: 'Стратегия развития',
      strategy_body: 'Мы сосредоточены на коммерческой недвижимости класса A++ в столицах Балтии и Западной Европы, премиальных жилых проектах в избранных локациях и оппортунистических девелоперских позициях.',
      history_title: 'История',
      history_body: 'UAB MAIŠIAGALA GROUP основана как частная инвестиционная платформа, стремящаяся стать предпочтительным партнёром для институциональных и частных инвесторов.',
    },
    investments: {
      title: 'Инвестиции',
      lead: 'Дисциплинированные позиции в трёх инвестиционных классах.',
      strategy_title: 'Инвестиционная стратегия',
      strategy_body: 'Мы оцениваем каждую сделку по внутреннему порогу IRR, устойчивости и архитектурной ценности. Наш портфель сбалансирован между генерацией пассивного дохода и ростом капитала.',
      categories: {
        commercial: { t: 'Коммерческая недвижимость', d: 'Офисы класса A++, торговые объекты и логистические комплексы.' },
        residential: { t: 'Жилая недвижимость', d: 'Премиальные квартиры и жилые проекты в избранных локациях.' },
        development: { t: 'Девелоперские проекты', d: 'Земля и позиции с высоким потенциалом создания ценности.' },
      },
    },
    realestate: {
      title: 'Недвижимость и строительство',
      lead: 'Полный цикл девелопмента — от земли до передачи.',
      services: [
        { t: 'Строительство', d: 'Высококачественное новое строительство с отобранными подрядчиками.' },
        { t: 'Реконструкция', d: 'Модернизация исторической и коммерческой недвижимости.' },
        { t: 'Девелопмент', d: 'Полный цикл девелопмента, включая проектирование, разрешения и финансирование.' },
        { t: 'Управление проектами', d: 'Профессиональное управление проектами в срок и в рамках бюджета.' },
      ],
    },
    asset: {
      title: 'Управление активами',
      lead: 'Профессионально. Дисциплинированно. Прозрачно.',
      services: [
        { t: 'Управление недвижимостью', d: 'Операционное управление, администрирование аренды, техническое обслуживание.' },
        { t: 'Управление инвестициями', d: 'Формирование портфеля, ребалансировка и мониторинг результатов.' },
        { t: 'Сопровождение и администрирование сделок', d: 'Управление приобретениями и продажами с юридическим и финансовым контролем.' },
        { t: 'Финансовый контроль', d: 'Отчётность, бюджетирование, налоговая оптимизация и аудит.' },
      ],
    },
    contact: {
      title: 'Контакты',
      lead: 'Свяжитесь с нами по вопросам инвестиций и партнёрства.',
      form: { name: 'Имя', phone: 'Телефон', email: 'Эл. почта', message: 'Сообщение', submit: 'Отправить', success: 'Спасибо! Мы свяжемся с вами в ближайшее время.', error: 'Произошла ошибка. Попробуйте снова.' },
      info: { phone: 'Телефон', email: 'Эл. почта', address: 'Адрес', address_value: 'ул. Кривю 5-1002, LT-01204, Вильнюс, Литва' },
    },
    footer: { rights: 'Все права защищены.', privacy: 'Политика конфиденциальности' },
    admin: { login: 'Войти через Google', title: 'Админ', projects: 'Проекты', news: 'Новости', messages: 'Сообщения', logout: 'Выйти', add: 'Добавить', edit: 'Редактировать', delete: 'Удалить', save: 'Сохранить', cancel: 'Отмена' },
  },
};
